import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-bag1-icon',
  templateUrl: './shopping-bag1.component.html'
})
export class ShoppingBag1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
